import React, { useState } from 'react';

function DynamicsSimulationModule({ onSubmit }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [method, setMethod] = useState('gromacs');

  const handleSubmit = () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append('pdbFile', selectedFile);
    formData.append('method', method);
    onSubmit('动力学模拟', formData, 'simulate');
  };

  return (
    <div className="flex flex-col h-full">
      <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} className="form-input" />
      <select value={method} onChange={(e) => setMethod(e.target.value)} className="form-select mt-2">
        <option value="gromacs">GROMACS</option>
        <option value="chaperong">CHAPERONg</option>
        <option value="openmm">OpenMM</option>
      </select>
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default DynamicsSimulationModule;

